import { API, graphqlOperation } from "aws-amplify";

const RETRIEVE_CARD_TYPES_QUERY = `query GetCardTypes($filter: Filter)
{
  getCardTypes(filter: $filter){
    cardTypeList{
      cardName
      shortCardName
      startingDigits
      constraints
    },
    nextToken,
    statusMessage    
  }
}`;
const CREATE_CARD_TYPE_MUTATION = `mutation CreateCardType($body: CardTypeInput!)
{
  createCardType(body: $body){
    statusMessage
  }
}`;
const DELETE_CARD_TYPE_MUTATION = `mutation DeleteCardType($shortCardName: String!)
{
  deleteCardType(shortCardName: $shortCardName){
    statusMessage
  }
}`;
const UPDATE_CARD_TYPE_MUTATION = `mutation UpdateCardType($body: CardTypeInput!)
{
  updateCardType(body: $body){
    statusMessage
  }
}`;

export default {
  methods: {
    async retrieveAllCardTypes(filter) {
      try {
        const response = await API.graphql(
          graphqlOperation(RETRIEVE_CARD_TYPES_QUERY, { filter: filter })
        );

        if (!response.data) throw new Error("No Data Was Sent Over.");

        const responseData = response.data.getCardTypes;
        if (
          responseData.statusMessage == "Successfully Retrieved Card Types."
        ) {
          let formattedList = responseData.cardTypeList.map(
            this.formatCardTypeList
          );
          return {
            cardTypeList: formattedList,
            nextToken: responseData.nextToken,
            statusMessage: responseData.statusMessage
          };
        }

        return {
          cardTypeList: [],
          nextToken: null,
          statusMessage: responseData.statusMessage
        };
      } catch (err) {
        this.$logger.error(err);
        return {
          cardTypeList: [],
          nextToken: null,
          statusMessage: err.message ? err.message : "Something Went Wrong."
        };
      }
    },
    formatCardTypeList(cardTypeList) {
      return {
        cardName: cardTypeList.cardName,
        shortCardName: cardTypeList.shortCardName,
        startingDigits: cardTypeList.startingDigits,
        constraints: JSON.parse(cardTypeList.constraints)
      };
    },
    async createCardType(cardTypeInfo) {
      cardTypeInfo = this.convertCardTypeIntElements(cardTypeInfo);
      cardTypeInfo.constraints = JSON.stringify(cardTypeInfo.constraints);
      try {
        const response = await API.graphql(
          graphqlOperation(CREATE_CARD_TYPE_MUTATION, { body: cardTypeInfo })
        );
        if (!response.data) throw new Error("No Data Was Sent Over.");

        const responseData = response.data.createCardType;
        return {
          statusMessage: responseData.statusMessage
        };
      } catch (err) {
        this.$logger.error(err);
        return {
          statusMessage: err.message ? err.message : "Something Went Wrong."
        };
      }
    },
    async deleteCardType(shortCardName) {
      try {
        const response = await API.graphql(
          graphqlOperation(DELETE_CARD_TYPE_MUTATION, {
            shortCardName: shortCardName
          })
        );
        if (!response.data) throw new Error("No Data Was Sent Over.");

        const responseData = response.data.deleteCardType;
        return {
          statusMessage: responseData.statusMessage
        };
      } catch (err) {
        this.$logger.error(err);
        return {
          statusMessage: err.message ? err.message : "Something Went Wrong."
        };
      }
    },
    async updateCardType(cardTypeInfo) {
      cardTypeInfo = this.convertCardTypeIntElements(cardTypeInfo);
      cardTypeInfo.constraints = JSON.stringify(cardTypeInfo.constraints);
      try {
        const response = await API.graphql(
          graphqlOperation(UPDATE_CARD_TYPE_MUTATION, { body: cardTypeInfo })
        );
        if (!response.data) throw new Error("No Data Was Sent Over.");

        let responseData = response.data.updateCardType;
        return {
          statusMessage: responseData.statusMessage
        };
      } catch (err) {
        this.$logger.error(err);
        return {
          statusMessage: err.message ? err.message : "Something Went Wrong."
        };
      }
    },
    convertCardTypeIntElements(cardTypeInfo) {
      cardTypeInfo.constraints.cardLength = this.convertToInt(
        cardTypeInfo.constraints.cardLength
      );
      return cardTypeInfo;
    },
    convertToInt(stringValue) {
      return parseInt(stringValue, 10);
    }
  }
};
